import React, { RefObject } from 'react';
import { KatDataGrid } from '@amzn/katal-react';
import '@amzn/katal-components/es/data-grid/data-grid.lightDOM.css';
import { licenseKey } from '@amzn/katal-ag-grid-enterprise-license-key';
import {
  LocalStorageKeys,
  getLocalStorageItem,
  setLocalStorageItem,
} from 'src/utilities/LocalStorage';
import { GridOptions } from '@amzn/katal-components/es/data-grid';

/**
 * Function executes after the grid is ready.
 * Responsible for updating the grid with pre-selectedfilter & sort params.
 * params: gridRef
 */
function onGridReady(gridRef: RefObject<KatDataGrid.Element>) {
  const dataGridFilterState = getLocalStorageItem(
    LocalStorageKeys.DATA_GRID_FILTER_STATE,
  );
  if (dataGridFilterState) {
    gridRef.current?.gridOptions?.api?.setFilterModel(
      JSON.parse(dataGridFilterState),
    );
  }
  const dataGridSortState = getLocalStorageItem(
    LocalStorageKeys.DATA_GRID_FILTER_STATE,
  );
  if (dataGridSortState) {
    gridRef.current?.gridOptions?.columnApi?.applyColumnState({
      state: JSON.parse(dataGridSortState),
    });
  }
}

/**
 * Function executes after user updates the sort.
 * Responsible for saving the sort param state
 * params: gridRef
 */
function onSortChanged(gridRef: RefObject<KatDataGrid.Element>) {
  setLocalStorageItem(
    LocalStorageKeys.DATA_GRID_SORT_STATE,
    JSON.stringify(gridRef.current?.gridOptions?.columnApi?.getColumnState()),
  );
}

/**
 * Function executes after user updates the filter.
 * Responsible for saving the filter param state
 * params: gridRef
 */
function onFilterChanged(gridRef: RefObject<KatDataGrid.Element>) {
  setLocalStorageItem(
    LocalStorageKeys.DATA_GRID_FILTER_STATE,
    JSON.stringify(gridRef.current?.gridOptions?.api?.getFilterModel()),
  );
}
interface DataGridProps extends KatDataGrid._OwnProps {
  items: Array<any>;
  columns: any;
}

const DataGrid: React.FC<DataGridProps> = ({
  items,
  columns,
  noResultsMessage,
  pagination = true,
  search = true,
  autoHeight = true,
}) => {
  const rowData = items.map((item) => ({ ...item }));
  const gridRef = React.createRef<KatDataGrid.Element>();

  const gridOptions: GridOptions = {
    onSortChanged: () => onSortChanged(gridRef),
    onFilterChanged: () => onFilterChanged(gridRef),
  };

  return (
    <KatDataGrid
      ref={gridRef}
      gridOptions={gridOptions}
      data-testid="KatClientSideDataGrid"
      pageSize={10}
      licenseKey={licenseKey}
      clientSideData
      search={search}
      autoHeight={autoHeight}
      columns={columns}
      rowData={rowData}
      noResultsMessage={noResultsMessage}
      pagination={pagination}
      onGridReady={(e: KatDataGrid.GridReadyEvent) => onGridReady(gridRef)}
    ></KatDataGrid>
  );
};

export default DataGrid;
